// @ts-ignore
import * as d3 from "d3";
import React, { useRef, useEffect} from "react";



function Gauge({
  _value,
  config = {
    width: 155,
    height: 83,
    inRad: 40,
    outRad: 50,
    cornRad: 14,
    arcLength: 230,
    bgFill: "#e9ecef",
    fgFill: "#198754",
    textSize: 24,
    textWeight: 600,
    threshold1: 75,
    thresholdFill1: "#dc3545",
    threshold2: 85,
    thresholdFill2: "#ffc107",
    delay: 500,
    duration: 1000,
  }
}) {


  var value = _value;
  var progress = value
  var oldProgress = 0.0;

  if (config.arcLength < 90) {
    config.arcLength = 90;
  }
  if (config.arcLength > 350) {
    config.arcLength = 350;
  }

  const containerWidth = config.width,
    containerHeight = config.height,
    margin = { top: 0, right: 0, bottom: 0, left: 0 },
    width = containerWidth - margin.left - margin.right,
    height = containerHeight - margin.top - margin.bottom,
    pi = Math.PI;
  var progressFill = config.thresholdFill2;

  const textRef = useRef(null);
  const bgArcRef = useRef(null);
  const fgArcRef = useRef(null);

  // Background Arc Defaults
  var bgArc = d3
    .arc()
    .innerRadius(config.inRad)
    .outerRadius(config.outRad)
    .startAngle(-0.5 * config.arcLength * (pi / 180))
    .cornerRadius(config.cornRad)
    .endAngle(calcAngle(100) * (pi / 180));

  // Foreground Arc Defaults
  var fgArc = d3
    .arc()
    .innerRadius(config.inRad)
    .outerRadius(config.outRad)
    .startAngle(-0.5 * config.arcLength * (pi / 180))
    .cornerRadius(config.cornRad)
    .endAngle(calcAngle(0.0) * (pi / 180))();

  useEffect(() => {
    var pi = Math.PI;
    if (config.arcLength < 90) {
      config.arcLength = 90;
    }
    if (config.arcLength > 350) {
      config.arcLength = 350;
    }

    // Apply Bg Arc to Bg Path
    d3.select(bgArcRef.current).style("fill", config.bgFill).attr("d", bgArc);

    // Apply Fg Arc to Fg Path
    d3.select(fgArcRef.current)
      .attr("id", "progress")
      .style("fill", progressFill)
      .transition()
      .duration(config.duration)
      .delay(config.delay)
      .attr("d", fgArc);

    // Append value text to svg
    d3.select(textRef.current)
      .attr("id", "value")
      .style("fill", config.bgFill)
      .style("vertical-align", "center")
      .style("text-align", "center")
      .style("font-size", config.textSize)
      .style("font-weight", config.textWeight)
      .attr("dominant-baseline", "middle")
      .attr("text-anchor", "middle")
      .text("--");
  }, []);

  useEffect(() => {
    value = _value;
    oldProgress = progress;
    //Data Validity
    if (value < 0) {
      value = 0;
    }
    if (value > 100) {
      value = 100;
    }

    if (value < config.threshold1) {
      progressFill = config.thresholdFill1;
    } else if (value < config.threshold2) {
      progressFill = config.thresholdFill2;
    } else {
      progressFill = config.fgFill;
    }

    //Progress Min Val
    if (value < 5) {
      progress = 5;
    } else {
      progress = value;
    }
  }, [_value]);

  useEffect(() => {
    var pi = Math.PI;
    // Arc Transition
    d3.select(fgArcRef.current)
      .transition()
      .duration(config.duration)
      .delay(config.delay)
      .attrTween("d", arcTween(calcAngle(oldProgress) * (pi / 180), calcAngle(progress) * (pi / 180)))
      .style("fill", progressFill);

    d3.select(textRef.current)
      .transition()
      .duration(config.duration)
      .delay(config.delay)
      .style("fill", progressFill)
      .text(precise(value, 1));

      function arcTween(oldData, newData) {
        var tweenArc = d3
        .arc()
        .innerRadius(config.inRad)
        .outerRadius(config.outRad)
        .startAngle(-0.5 * config.arcLength * (pi / 180))
        .cornerRadius(config.cornRad);
        //.endAngle(calcAngle(oldProgress) * (pi / 180))();
        const copy = { ...oldData };
        return function () {
          const interpolateEndAngle = d3.interpolate(oldData, newData);
      
          return function (t) {
            copy.endAngle = interpolateEndAngle(t);
            return tweenArc(copy);
          };
        };
      }

  }, [progress]);


  function calcAngle(value) {
    //Data Validity
    var percent = value / 100;
    if (percent < 0) {
      percent = 0;
    }
    if (percent > 1) {
      percent = 1;
    }

    var angle = percent * config.arcLength - 0.5 * config.arcLength;
    return angle;
  }

function precise(x, precision) {
      // @ts-ignore
  return Number.parseFloat(x).toFixed(precision);
      //return Number.parseFloat(x).toPrecision(4);
    }

function separate(x) {
      return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }



  return (
    <div>
      <svg viewBox={"0 0 " + containerWidth + " " + containerHeight}>
        <g
          transform={
            "translate(" +
            (margin.left + width / 2) +
            "," +
            (margin.top + (height / 3) * 2) +
            ")"
          }
        >
          <path ref={bgArcRef}/>
          <path ref={fgArcRef}/>
          <text ref={textRef}></text>
        </g>
      </svg>
    </div>
  );
}

export default Gauge;
